module.exports = __webpack_public_path__ + "img/leftWhite.010c2d2d.svg";